/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OWGameEventMap } from './OWGameEventMap';
import {
    OWGameEventMapFromJSON,
    OWGameEventMapFromJSONTyped,
    OWGameEventMapToJSON,
    OWGameEventMapToJSONTyped,
} from './OWGameEventMap';

/**
 * 
 * @export
 * @interface GetOverwolfEventMappingsResponse
 */
export interface GetOverwolfEventMappingsResponse {
    /**
     * 
     * @type {Array<OWGameEventMap>}
     * @memberof GetOverwolfEventMappingsResponse
     */
    eventMappings: Array<OWGameEventMap>;
}

/**
 * Check if a given object implements the GetOverwolfEventMappingsResponse interface.
 */
export function instanceOfGetOverwolfEventMappingsResponse(value: object): value is GetOverwolfEventMappingsResponse {
    if (!('eventMappings' in value) || value['eventMappings'] === undefined) return false;
    return true;
}

export function GetOverwolfEventMappingsResponseFromJSON(json: any): GetOverwolfEventMappingsResponse {
    return GetOverwolfEventMappingsResponseFromJSONTyped(json, false);
}

export function GetOverwolfEventMappingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOverwolfEventMappingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'eventMappings': ((json['eventMappings'] as Array<any>).map(OWGameEventMapFromJSON)),
    };
}

export function GetOverwolfEventMappingsResponseToJSON(json: any): GetOverwolfEventMappingsResponse {
    return GetOverwolfEventMappingsResponseToJSONTyped(json, false);
}

export function GetOverwolfEventMappingsResponseToJSONTyped(value?: GetOverwolfEventMappingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventMappings': ((value['eventMappings'] as Array<any>).map(OWGameEventMapToJSON)),
    };
}

